// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1r1V0","questions":"styles_questions__ZfVtz","footer":"styles_footer__8DfVq"};